import React, { useState } from "react";
import { Table, Avatar, Tag } from "antd";
import Wrapper from "../../UI/Wrapper";
import Sidebar from "../../components/Common/Sidebar";
import Main from "../../components/FormScreen/Main";
import { useGetRefundHistoryQuery } from "../../services/bookingApi";
import { BASE_URL } from "../../keys";


const formatSessionDate = (date, time, timeZone) => {
  if (!date || !time) return "-";

  const utcDate = new Date(`${date}T${time}:00Z`);

  return new Intl.DateTimeFormat("en-GB", {
    timeZone,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(utcDate);
};
const formatSessionTime = (date, time, timeZone) => {
  if (!date || !time) return "-";
  const utcDate = new Date(`${date}T${time}:00Z`);

  return new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(utcDate);
};

const formatCreatedAt = (timestamp, timeZone) => {
  if (!timestamp) return "-";

  return new Intl.DateTimeFormat("en-GB", {
    timeZone,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(timestamp * 1000));
};
const RefundHistory = () => {
  const deviceTimezone =
    localStorage.getItem("device_timezone") || "Asia/Dubai";

  const [page,setPage] = useState(1);
  const pageSize=10
  
  const { data, isLoading } = useGetRefundHistoryQuery({
    page,
    limit:pageSize,
  });
const hasNextPage = data?.data && data.data.length === pageSize;
console.log(hasNextPage);


  const tableData =
    data?.data?.map((item) => ({
      key: item.id,
      coach: {
        name: `${item.coach__first_name?.trim()} ${item.coach__last_name?.trim()}`,
        email: item.coach__email,
        img: item.coach__userprofile__profile_pic,
      },
      sessionDate: formatSessionDate(
        item.session_date,
        item.session_time,
        deviceTimezone
      ),
      sessionTime: formatSessionTime(
        item.session_date,
        item.session_time,
        deviceTimezone
      ),
      refundAppliedDate: formatCreatedAt(
        item.payment_details?.created_at,
        deviceTimezone
      ),
      amount: `${item.amount} ${item.currency}`,
      refundId: item.refund_id,
      paymentId: item.payment_details?.id,
      status: item.refund_status,
      category:item?.category__name
    })) || [];


  const columns = [
    {
      title: "Coach Name",
      dataIndex: "coach",
      key: "coach",
      width: 260,
      render: (coach) => (
        <div className="flex items-center gap-3">
          <Avatar
            src={coach.img ? BASE_URL + coach.img : "/avatar.png"}
            size={48}
          />
          <div>
            <div className="font-medium">{coach.name}</div>
            <div className="text-gray-400 text-sm truncate max-w-[180px]">
              {coach.email}
            </div>
          </div>
        </div>
      ),
    },
    {
        title:'Category',
dataIndex:"category",
key:'category',
width:140
    },
    {
      title: "Session Date",
      dataIndex: "sessionDate",
      key: "sessionDate",
      width: 140,
    },
    {
      title: "Session Time",
      dataIndex: "sessionTime",
      key: "sessionTime",
      width: 120,
    },
    {
      title: "Refund Initiation Date",
      dataIndex: "refundAppliedDate",
      key: "refundAppliedDate",
      width: 200,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      width: 110,
    },
    {
      title: "Refund ID",
      dataIndex: "refundId",
      key: "refundId",
      width: 220,
      render: (id) => (
        <span className="text-xs break-all">{id}</span>
      ),
    },
    {
      title: "Payment ID",
      dataIndex: "paymentId",
      key: "paymentId",
      width: 220,
      render: (id) => (
        <span className="text-xs break-all">{id}</span>
      ),
    },
   
    {
  title: "Status",
  dataIndex: "status",
  key: "status",
  width: 140,
  render: (status) => {
    const statusColorMap = {
      created: "blue",
      processed: "green",
      failed: "red",
      fully_refunded: "purple",
    };

    return (
      <Tag color={statusColorMap[status] || "default"}>
        {status.replace("_", " ")}
      </Tag>
    );
  },
}
  ];
   const handlePrevious = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleNext = () => {
    if (hasNextPage) {
      setPage(page + 1);
    }
  };

  return (
    <Wrapper>
      <div className="flex">
        <Sidebar notLoggedIn={false} />
        <Main>
          <div className="w-full bg-[#fff6ee] rounded-3xl p-8 overflow-scroll">
            <div className="bg-white rounded-3xl p-8 shadow-sm">
              <h2 className="text-2xl font-semibold mb-6">
                Refund History
              </h2>

              <Table
                columns={columns}
                dataSource={tableData}
                loading={isLoading}
                pagination={false}
                scroll={{ x: 1200 }}
              />
               <div className="flex justify-end gap-3 items-center mt-6">
                <button
                  onClick={handlePrevious}
                  disabled={page === 1}
                  className={`px-4 py-2 rounded-lg font-medium ${
                    page === 1
                      ? 'bg-gray-200 text-gray-600 cursor-not-allowed'
                      : 'bg-orange text-white hover:bg-orange-600'
                  }`}
                >
                  Previous
                </button>
                
                {/* <span className="text-gray-600">
                  Page {page}
                </span> */}

                <button
                  onClick={handleNext}
                  disabled={!hasNextPage}
                  className={`px-4 py-2 rounded-lg font-medium ${
                    !hasNextPage
                      ? 'bg-gray-200 text-gray-600 cursor-not-allowed'
                      : 'bg-orange text-white hover:bg-orange-600'
                  }`}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Main>
      </div>
    </Wrapper>
  );
};

export default RefundHistory;
